import { useEffect, useState } from 'react';
import { MOBILE_WIDTH } from '../utils/constants';

export default function useIsMobile() {
  const isBrowser = () => typeof window !== 'undefined';

  const getIsMobile = () => isBrowser() ? window.innerWidth < MOBILE_WIDTH : false;

  const [isMobile, setIsMobile] = useState(getIsMobile());

  useEffect(() => {
    const onResize = () => {
      setIsMobile(getIsMobile());
    };

    window.addEventListener('resize', onResize);
    
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);
    
  return isMobile;
}